const u = (id, w = 1600, q = 80) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=${q}`;

export const SITE = {
  name: "Nanak Chauffeurs",
  domain: "NanakChauffeurs.com",
  email: "info@nanakchauffeurs.com",
  // TODO(owner): add dispatch phone as "+1 (xxx) xxx-xxxx"; phone CTAs are hidden while empty
  phone: "",
  phoneHref: "",
  booking: "https://book.mylimobiz.com/v4/nanak",
  bookingAlias: "nanak",
  bookingScript: "https://book.mylimobiz.com/v4/widgets/widget-loader.js",
  // TODO(owner): confirm service area wording
  area: "Local & long-distance · All major airports and private FBOs",
};

// Departmental Google Workspace addresses (see owner action items re: alias/group/mailbox setup)
export const EMAILS = {
  general: "info@nanakchauffeurs.com",
  reservations: "reservations@nanakchauffeurs.com",
  dispatch: "dispatch@nanakchauffeurs.com",
  support: "support@nanakchauffeurs.com",
  corporate: "corporate@nanakchauffeurs.com",
  billing: "billing@nanakchauffeurs.com",
  drivers: "drivers@nanakchauffeurs.com",
};

export const CONTACT_DIRECTORY = [
  { dept: "General Inquiries", email: EMAILS.general },
  { dept: "Reservations", email: EMAILS.reservations },
  { dept: "Corporate & Affiliates", email: EMAILS.corporate },
  { dept: "Customer Support", email: EMAILS.support },
  { dept: "Billing", email: EMAILS.billing },
];

export const IMG = {
  heroDesktop: "/img/hero-escalade-jet-desktop.jpg",
  heroMobile: "/img/hero-escalade-jet-mobile.jpg",
  escaladeHotel: "/img/escalade-hotel-night.jpg",
  suvCabin: "/img/suv-interior-cabin.jpg",
  hero: u("photo-1764605206511-7a649d9df63b", 2400, 85),
  chauffeur: u("photo-1627285886624-5cd637dafb50"),
  tuxedo: u("photo-1558222209-134191edfe0d"),
  cabin: u("photo-1612065242504-3cf688429706"),
  sedan: u("photo-1780296269675-169390638617"),
  sedanAlt: u("photo-1771210353591-20006eba7ad7"),
  suv: u("photo-1735620731955-b047a7122892"),
  suburban2023:
    "https://images.pexels.com/photos/36377051/pexels-photo-36377051.jpeg?auto=compress&cs=tinysrgb&w=1600",
  suburban2022:
    "https://images.pexels.com/photos/36377053/pexels-photo-36377053.jpeg?auto=compress&cs=tinysrgb&w=1600",
  suvs: u("photo-1769787301187-0fab290ba2f2"),
  limo: "https://images.pexels.com/photos/19927823/pexels-photo-19927823.jpeg?auto=compress&cs=tinysrgb&w=1600",
  van: u("photo-1534756287545-6b3a471d4e0e"),
  vanInterior: u("photo-1750210506021-05f1f5bdad23"),
  corporate:
    "https://images.pexels.com/photos/37098542/pexels-photo-37098542.jpeg?auto=compress&cs=tinysrgb&w=1600",
  city: "https://images.pexels.com/photos/15535501/pexels-photo-15535501.jpeg?auto=compress&cs=tinysrgb&w=1600",
  wedding: u("photo-1592514313074-794923c98162"),
  night: u("photo-1714624257449-b5495d1b8278"),
};

export const FLEET = [
  {
    id: "suburban-2023",
    name: "2023 Chevrolet Suburban Premier",
    models: "Full-size luxury SUV · Black",
    img: IMG.suburban2023,
    pax: "6",
    bags: "6",
    blurb:
      "Our newest Suburban Premier — leather captain's chairs, a whisper-quiet cabin and room for everyone's luggage.",
    tags: ["Leather captain's chairs", "Rear-seat climate", "Wi-Fi hotspot", "Bose premium audio"],
  },
  {
    id: "suburban-2022",
    name: "2022 Chevrolet Suburban Premier",
    models: "Full-size luxury SUV · Black",
    img: IMG.suburban2022,
    pax: "6",
    bags: "6",
    blurb:
      "The executive workhorse: panoramic sunroof, heated and ventilated seats, and a cargo bay built for airport runs.",
    tags: ["Panoramic sunroof", "Heated & ventilated seats", "USB at every seat", "Child seats on request"],
  },
];

export const TESTIMONIALS = [
  // TODO(owner): replace these placeholder quotes with real rider reviews
  {
    quote:
      "Harry was waiting at arrivals before our flight even landed. Spotless Suburban, cold water, zero stress. Exactly what business travel should feel like.",
    name: "Placeholder — Replace with real review",
    occasion: "Airport Transfer",
  },
  {
    quote:
      "Booked for our wedding day and the car looked better than the venue. Punctual, polite and the ride was so smooth nobody wrinkled a thing.",
    name: "Placeholder — Replace with real review",
    occasion: "Wedding",
  },
  {
    quote:
      "Three back-to-back meetings across town and we never once looked at the clock. Discreet, professional, immaculate.",
    name: "Placeholder — Replace with real review",
    occasion: "Corporate Travel",
  },
  {
    quote:
      "Our group of six plus luggage fit comfortably. The chauffeur handled every detail — we just enjoyed the ride.",
    name: "Placeholder — Replace with real review",
    occasion: "Group Trip",
  },
];

export const SERVICES = [
  {
    id: "executive",
    no: "01",
    title: "Executive Transportation",
    img: IMG.escaladeHotel,
    desc: "Point-to-point and hourly service for executives who measure a journey in composure, not just miles. A new-generation black Escalade, a professional chauffeur, and an arrival that sets the tone.",
    points: ["Hourly & point-to-point", "Discreet professional chauffeurs", "Immaculate late-model SUVs"],
  },
  {
    id: "airport",
    no: "02",
    title: "Airport Transfers",
    img: IMG.heroDesktop,
    desc: "Seamless transfers to and from every major airport and private FBO. Your chauffeur tracks the flight, waits on your schedule, and is in position before you reach the curb.",
    points: ["Live flight tracking", "Meet & greet", "Generous complimentary wait time"],
  },
  {
    id: "corporate",
    no: "03",
    title: "Corporate Transportation",
    img: IMG.corporate,
    desc: "Reliable ground transportation for companies, roadshows and visiting clients — coordinated, consistent and invoiced with the discretion your organization expects.",
    points: ["Multi-stop roadshows", "Consolidated billing", "Priority dispatch"],
  },
  {
    id: "private-chauffeur",
    no: "04",
    title: "Private Chauffeur Services",
    img: IMG.chauffeur,
    desc: "A dedicated chauffeur for the day or the evening — errands, dinners, events and everything in between, handled with poise and absolute privacy.",
    points: ["Dedicated chauffeur", "As-directed by the hour", "Complete discretion"],
  },
  {
    id: "suv",
    no: "05",
    title: "Professional SUV Transportation",
    img: IMG.suvCabin,
    desc: "Full-size luxury SUVs with room for your party and their luggage, finished in leather and climate comfort — the quietest, most composed way to move a group.",
    points: ["Up to 6 passengers", "Generous luggage capacity", "Leather, climate-controlled cabin"],
  },
];

export const MARQUEE_ITEMS = [
  "Airport Transfers",
  "Corporate Travel",
  "Weddings",
  "Prom Nights",
  "City & Wine Tours",
  "Hourly Charter",
  "FBO Pickups",
  "Intercity Transfers",
];
